import { useEffect, useState } from 'react';
import { safeInvoke, isTauri } from '@/utils/tauri';
import { useLifecycleTracker } from '@/utils/memoryLeak';

export const useWindowPosition = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [size, setSize] = useState({ width: 400, height: 800 });
  const lifecycleTracker = useLifecycleTracker();

  useEffect(() => {
    if (!isTauri()) {
      // 浏览器环境，跳过窗口位置设置
      return;
    }

    const initializeWindow = async () => {
      try {
        // 等待窗口加载完成
        await new Promise<void>(resolve => {
          const timer = lifecycleTracker.setTimeout(() => resolve(), 100);
          lifecycleTracker.registerCleanup(() => clearTimeout(timer));
        });
        
        // 获取屏幕尺寸
        const screenSize = await safeInvoke<[number, number]>('get_screen_size');
        
        // 获取窗口尺寸
        const windowSize = await safeInvoke<[number, number]>('get_window_size');
        
        if (screenSize && windowSize) {
          const [screenWidth, screenHeight] = screenSize;
          const [windowWidth, windowHeight] = windowSize;
          
          // 计算右侧位置
          const x = screenWidth - (windowWidth || 400);
          const y = (screenHeight - (windowHeight || 800)) / 2;
          
          // 设置窗口位置
          await safeInvoke('set_window_position', { x, y });
          setPosition({ x, y });
          setSize({ width: windowWidth || 400, height: windowHeight || 800 });
        }
      } catch (error) {
        console.error('初始化窗口位置失败:', error);
      }
    };

    initializeWindow();
  }, [lifecycleTracker]);

  return { position, size };
};

